import React, { useState } from "react";
import "./TableCardSelector.scss";

export default function TableCardSelector({ tabs }) {
  const [active, setActive] = useState(0);

  return (
    <div className="data-estate-table-container">
      <div className="tab-toggle">
        {tabs.map((tab, index) => (
          <div key={tab.name} className="toggle-wrapper">
            <button
              className={`toggle-item ${active === index ? "active" : ""}`}
              onClick={() => setActive(index)}
            >
              {tab.name}
            </button>
            {index !== tabs.length - 1 && <div className="data-estate-divider" />}
          </div>
        ))}
      </div>
      <div className="tab-content">{tabs[active].component}</div>
    </div>
  );
}
